import can from 'can';
import {BaseMap} from '../../js/usga.base-map';
import {LeaderBoardBaseMap} from '../leaderboard-base/leaderboard-base-map';

const videoPath = globalSettings.pagePaths.video;

export const LeaderBoardTickerModel = LeaderBoardBaseMap.extend({
	define: {
		items: {
			Type: BaseMap.List,
			Value: BaseMap.List
		},
		tableType: {
			type: 'string',
			value: ''
		},
		tabs: {
			Type: BaseMap.List,
			Value: BaseMap.List
		}
	},
	isChosen: false,
	selectedTabIndex: 0,
	selectedTab: function () {
		return this.attr('tabs').attr(this.attr('selectedTabIndex'));
	},
	liveLink: videoPath,
	isStroke: can.compute(function () {
		return this.attr('tableType') == 'stroke';
	}),
	isMatch: can.compute(function () {
		return this.attr('tableType') == 'match';
	}),
	isCup: can.compute(function () {
		return this.attr('tableType') == 'cup';
	})
});